import { z } from "zod"

import { ATTACHMENT_DESCRIPTION_MAX_LENGTH } from "@/components/upload/constants"

export const attachFilesFormSchema = z.object({
  files: z
    .array(
      z.object({
        file: z.instanceof(File),
        documentType: z.string().min(1, "Type is required"),
        description: z
          .string()
          .max(
            ATTACHMENT_DESCRIPTION_MAX_LENGTH,
            `Description must not exceed ${ATTACHMENT_DESCRIPTION_MAX_LENGTH} characters`
          )
          .optional()
          .default(""),
      })
    )
    .min(1, "At least one file is required"),
})

export type AttachFilesFormValues = z.infer<typeof attachFilesFormSchema>
